<template>
<div v-if="signed">
    <div v-if="list.length">
        <simple-menu :menu-list="menuList"></simple-menu>
        <div class="small-app-content">
            <router-view :list="list" @refresh="getAppList"></router-view>
        </div>
    </div>
    <div v-else class="empty">
        你暂时没有关联的小程序～
    </div>
</div>
<access-deny v-else></access-deny>
</template>
<script>
import SimpleMenu from '@/components/Menu';
import bus from '@/lib/bus.js';
import AccessDeny from '@/components/AccessDeny.vue';
import dao from '@/lib/dao.js';
export default {
    components: {
        SimpleMenu,
        AccessDeny
    },
    data() {
        return {
            menuList: [
                {
                    name: '小程序管理',
                    route: '/up/manage'
                },
                {
                    name: '展示预览',
                    route: '/up/preview'
                },
            ],
            list: [],
            signed: true
        }
    },
    methods: {
        getAppList() {
            dao.up.getUpAppList().then(data => {
                this.list = data.list;
            }).catch(response => {
                if (response.code !== 83001003) {
                    this.$message.error(msg);
                } else {
                    this.list = [];
                }
            });
        }
    },
    mounted() {
        dao.up.getUpInfo().then(data => {
            bus.username = data;
            bus.type = 'up';
            this.getAppList();
        }).catch(response => {
            if (response.code === 83001002) {
                this.signed = false;
            } else if (response.code === 83001003) {
                bus.type = 'up';
                bus.username = response.data;
                this.$message.error(response.message);
            }
        });
    }
}
</script>
<style lang="less" scoped>
.empty {
    margin-top: 100px;
    padding-top: 170px;
    text-align: center;
    font-size: 14px;
    color: #5C667E;
    background: url(../../assets/empty.png) center 0 no-repeat;
    background-size: 298px 153px;
}
.small-app-content {
    display: inline-block;
    margin-left: 20px;
    width: 1015px;
}
</style>



// WEBPACK FOOTER //
// src/page/upManage/Main.vue